import { useWeb3React } from './useWeb3React';
import { UI_SUPPORTED_CHAINS } from 'constants/chains';
import { platformTokens } from 'constants/tokens';

import { isTestnetChain } from 'utils/chains';

export const usePlatformToken = () => {
  const { chainId } = useWeb3React();

  if (chainId && UI_SUPPORTED_CHAINS.includes(chainId)) {
    const isTestnet = isTestnetChain(chainId);

    if (isTestnet) {
      return platformTokens.testnet;
    }

    return platformTokens.mainnet;
  }

  const isConfigTestnet =
    process.env.REACT_APP_DEFAULT_NETWORK_TESTNET === 'true';
  if (isConfigTestnet) {
    return platformTokens.testnet;
  }

  return platformTokens.mainnet;
};
